export default "__VITE_ASSET__rMFzGM0x__"